import { render, staticRenderFns } from "./InputTelephone.vue?vue&type=template&id=5c4443c6&scoped=true"
import script from "./InputTelephone.vue?vue&type=script&lang=js"
export * from "./InputTelephone.vue?vue&type=script&lang=js"
import style0 from "./InputTelephone.vue?vue&type=style&index=0&id=5c4443c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4443c6",
  null
  
)

export default component.exports